import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    let mainSliders = [];

    const initSliders = () => {
        const fullSliders = document.querySelectorAll('.full-slider');

        fullSliders.forEach(function (fullSlider) {
            const thumbSlider = new Swiper(fullSlider.querySelector(".full-slider__thumb-slider"), {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                slidesPerView: 1,
            });

            const autoplayDelay = parseInt(fullSlider.dataset.autoplayDelay) || 3000;

            const mainSlider = new Swiper(fullSlider.querySelector(".full-slider__main"), {
                loop: true,
                effect: "fade",
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                },
                thumbs: {
                    swiper: thumbSlider,
                },
            });

            mainSliders.push(mainSlider);
        });
    };

    initSliders();

    window.addEventListener('resize', function () {
        mainSliders.forEach(function (slider) {
            slider.destroy();
        });

        mainSliders = [];

        initSliders();
    });
});
